import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import sharedStyles from "../compare-and-favourite-bar.module.css";
import { HeartFilledIcon, HeartOutlineIcon } from "@cinch-nx/design-system-icons";
import cx from "classnames";
export var FavouriteCTA = function(param) {
    var isSaved = param.isSaved, onClick = param.onClick;
    var FAVOURITE_CAR = "Add car to favourites";
    var UNFAVOURITE_CAR = "Remove car from favourites";
    var FavouriteIcon = isSaved ? HeartFilledIcon : HeartOutlineIcon;
    return /*#__PURE__*/ _jsx("div", {
        className: sharedStyles.ctaWrapper,
        children: /*#__PURE__*/ _jsxs("button", {
            type: "button",
            "aria-label": isSaved ? UNFAVOURITE_CAR : FAVOURITE_CAR,
            className: cx(sharedStyles.ctaButton, isSaved && sharedStyles.toggled),
            onClick: onClick,
            children: [
                /*#__PURE__*/ _jsx(FavouriteIcon, {
                    size: 16
                }),
                "Favourite"
            ]
        })
    });
};
